module.exports = __webpack_public_path__ + "static/media/chart-line.b453636e.svg";